import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { Grid, Typography } from "@mui/material";

const SettingDropdown = ({ isOpenDropDown, toggle, CompanyUrl }) => {
  const navigate = useNavigate();

  return (
    <Grid className="d-flex justify-content-between ">
      <Grid className="setting-dropdown settingsidebardrop mb-0">
        <Dropdown
          isOpen={isOpenDropDown}
          toggle={toggle}
          className="settingProfileSetting"
        >
          <DropdownToggle className="back-color" caret>
            Setting
          </DropdownToggle>
          <DropdownMenu style={{ zIndex: "9" }}>
            <DropdownItem>
              <Typography style={{ fontWeight: 600 }}>
                MANAGE <br />
                Account
              </Typography>
            </DropdownItem>
            <DropdownItem
              style={{
                textDecoration: "none",
                color: "#4F963B",
                display: "block",
              }}
              className="dropdown-link-setting"
              onClick={() => {
                navigate(
                  CompanyUrl ? `/${CompanyUrl}/account` : "/superadmin/account",
                  {
                    state: { navigats: ["/index", "/account"] },
                  }
                );
              }}
            >
              Accounts
            </DropdownItem>

            <DropdownItem>
              <Typography style={{ fontWeight: 600 }}>
                BUSINESS <br /> MANAGEMENT
              </Typography>
            </DropdownItem>
            <DropdownItem
              className="dropdown-link-setting"
              onClick={(e) => {
                navigate(
                  CompanyUrl
                    ? `/${CompanyUrl}/materials-labor`
                    : "/superadmin/materials-labor",
                  {
                    state: {
                      navigats: ["/index", "/materials-labor"],
                    },
                  }
                );
              }}
              style={{
                textDecoration: "none",
                color: "#4F963B",
                display: "block",
              }}
            >
              Materials & Labor
            </DropdownItem>

            <DropdownItem>
              <Typography style={{ fontWeight: 600 }}>
                TEAM <br /> ORGANIZATION
              </Typography>
            </DropdownItem>
            <DropdownItem
              style={{
                textDecoration: "none",
                color: "#4F963B",
                display: "block",
              }}
              className="dropdown-link-setting"
              onClick={() => {
                navigate(
                  CompanyUrl
                    ? `/${CompanyUrl}/manageteam`
                    : "/superadmin/manageteam",
                  {
                    state: { navigats: ["/index", "/manageteam"] },
                  }
                );
              }}
            >
              Manage Team
            </DropdownItem>

            <DropdownItem>
              <Typography style={{ fontWeight: 600 }}>
                MANAGE <br />
                TEMPLATES
              </Typography>
            </DropdownItem>
            <DropdownItem
              style={{
                textDecoration: "none",
                color: "#4F963B",
                display: "block",
              }}
              className="dropdown-link-setting"
              onClick={() => {
                navigate(
                  CompanyUrl
                    ? `/${CompanyUrl}/manage-template`
                    : "/superadmin/manage-template",
                  {
                    state: { navigats: ["/index", "/manage-template"] },
                  }
                );
              }}
            >
              Templates
            </DropdownItem>

            <DropdownItem>
              <Typography style={{ fontWeight: 600 }}>
                MANAGE <br />
                Visits
              </Typography>
            </DropdownItem>
            <DropdownItem
              style={{
                textDecoration: "none",
                color: "#4F963B",
                display: "block",
              }}
              className="dropdown-link-setting"
              onClick={() => {
                navigate(
                  CompanyUrl
                    ? `/${CompanyUrl}/manage-visits`
                    : "/superadmin/manage-visits",
                  {
                    state: { navigats: ["/index", "/manage-visits"] },
                  }
                );
              }}
            >
              Visits
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Grid>
    </Grid>
  );
};

export default SettingDropdown;
